module.exports = __webpack_public_path__ + "img/info.001.76294577.jpeg";